import React from "react";
import { makeStyles } from "@material-ui/styles";
import { FruProButton } from "@components";

const useStyles = makeStyles((theme) => ({
  customButton: {
    width: "100%",
    height:"60px !important",
    fontWeight: 700,
    borderRadius:"20px !important",
    background: `${theme.palette.primary.primaryB} !important`,
  },
}));

export default function SubmitButton(props) {
  const classes = useStyles();
  return (
    <FruProButton className={classes.customButton} noMargin {...props}>
      {props.children}
    </FruProButton>
  );
}
